
// Slick carousel (used on testimonials) http://kenwheeler.github.io/slick/
//import jquery from 'jquery'

import 'slick-carousel';

// window.jQuery = window.$ = $;

// Slick (Slider) http://kenwheeler.github.io/slick/
// Better include this before basicscroll
(function($) { "use strict";



	//
	// Image Carousel
	//
	$('.image-carousel').slick({
		slidesToShow: 1,
		centerMode: true,
		centerPadding: "10%",
		prevArrow: '<span class="slide-nav-button icon-arrow-circled--left"></span>',
		nextArrow: '<span class="slide-nav-button icon-arrow-circled--right"></span>',
		appendArrows: '.image-carousel__nav',
		speed: 500,
		responsive: [
			{
				breakpoint: 500,
				settings: {
					centerPadding: "5%",
				}
			}
		]
	});


	//
	// Hero Slider
	//
	var $slider = $('.js-hero-slider');
	
	// check page contains element
	if( $slider.length ) {
	

		$('.hero-slide')
			.on('activate-slide-colors', function (e, eventInfo) {
				// console.log($(this).attr('class'));
				//remove current js-hero-is-style-bg-? and js-hero-is-style-fg-? classes in body
				let body_classes = $('body').attr('class').split(/\s+/);
				$.each(body_classes, function(index, classname) {
					if (classname.startsWith('js-hero-is-style-fg-') || classname.startsWith('js-hero-is-style-bg-') || classname.startsWith('js-hero-is-style-accent-1-') || classname.startsWith('js-hero-is-style-accent-2-')) {
						$('body').removeClass(classname);
					}
				});

				//add js-hero-is-bg-? and js-hero-is-fg-? classes to body, following the NEXT slide color scheme
				let current_slide_classes = $(this).attr('class').split(/\s+/);
				// console.log(current_slide_classes);
				$.each(current_slide_classes, function(index, classname) {
					if (classname.startsWith('is-style-fg-') || classname.startsWith('is-style-bg-') || classname.startsWith('is-style-accent-1-') || classname.startsWith('is-style-accent-2-')) {
						$('body').addClass('js-hero-' + classname);
					}
				});
			})
			.eq(0)
			.trigger('activate-slide-colors') //trigger the colors at page loading
		;

		
		// On first initialization
		// $slider.on('init', function(slick) {		
			
		// 	// To trigger the first item's transition on page load
		// 	firstItem.removeClass('slick-active');
			
		// 	setTimeout(function() {
		// 		firstItem.addClass('slick-active');
		// 	}, 1);

		// });

		
		// On before slide change
		$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
			
			$('body').addClass('js-hero-active'); //Used to adjust animation-duration in CSS after the first slide is cycled.	
			
			$('.hero-slide', slick.$slides[nextSlide]).trigger('activate-slide-colors');

		});
	
		
		// initialize and configure.
		$slider.slick({
			fade: true,
			dots: false,
			arrows: true,
			prevArrow: '<span class="slide-nav-button icon-arrow-circled--left"></span>',
			nextArrow: '<span class="slide-nav-button icon-arrow-circled--right"></span>',
			appendArrows: '.hero-slider__nav__buttons',
			pauseOnFocus: false,
			pauseOnHover: false,
			draggable: false,
			touchMove: false,
			swipeToSlide: false,
			swipe: false,
			autoplay: false,
			infinite: true,
			autoplaySpeed: 5000,
			speed: 2000,
		});
		
		
	}


	//
	// Tease Slider
	//
	// check page contains element
	if( $('.js-tease-slider').length ) {


		$('.js-tease-slider').slick({
			dots: false,
			arrows: true,
			slidesToShow: 4,
			slidesToScroll: 1,
			infinite: false,
			variableWidth: true,
			pauseOnHover: true,
			autoplay: false,
			touchThreshold: 30,
			// speed: 300,
			prevArrow: '<span class="slide-nav-button icon-arrow-circled--left"></span>',
			nextArrow: '<span class="slide-nav-button icon-arrow-circled--right"></span>',
			appendArrows: '.tease-slider__nav__buttons',
			responsive: [
				{
					breakpoint: 1450,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 1060,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 700,
					settings: {
						// centerMode: true,
						// centerPadding: '0px',
						slidesToShow: 1
					}
				}
			]
		})
	}


	


	//
	// Hero Text With Slider
	//
	// check page contains element
	if( $('.hero-text-with-slider').length ) {


		$('.hero-text-with-slider').slick({
			dots: false,
			arrows: true,
			prevArrow: '<span class="slide-nav-button icon-arrow-circled--left"></span>',
			nextArrow: '<span class="slide-nav-button icon-arrow-circled--right"></span>',
			appendArrows: '.hero-text-with-slider__nav',
			slidesToShow: 3,
			slidesToScroll: 1,
			// pauseOnFocus: false,
			variableWidth: true,
			pauseOnHover: true,
			autoplay: false,
			centerMode: false,
			touchThreshold: 30,
			infinite: true,
			// rtl: true,
			// autoplaySpeed: 4000,
			// speed: 300,
			// responsive: [
			// 	{
			// 		breakpoint: 1000,
			// 		settings: {
			// 			centerMode: true,
			// 			centerPadding: '40px',
			// 			slidesToShow: 2
			// 		}
			// 	},
			// 	{
			// 		breakpoint: 750,
			// 		settings: {
			// 			centerMode: true,
			// 			centerPadding: '100px',
			// 			slidesToShow: 1
			// 		}
			// 	},
			// 	{
			// 		breakpoint: 650,
			// 		settings: {
			// 			centerMode: true,
			// 			centerPadding: '0px',
			// 			slidesToShow: 1
			// 		}
			// 	}
			// ]
		});
	}





	//
	// History Slider
	//
	// check page contains element
	if( $('.js-explore-history-slider').length ) {


		$('body').addClass('js-current-slide-0');

		// $('.timeline__event:first').addClass('timeline__first-event');
		// $('.timeline__event:last').addClass('timeline__last-event');


		$('.js-explore-history-slider').slick({
			dots: false,
			arrows: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: false,
			variableWidth: true,
			pauseOnHover: true,
			autoplay: false,
			touchThreshold: 30,
			// speed: 300,
			prevArrow: '<span class="slide-nav-button icon-arrow-circled--left"></span>',
			nextArrow: '<span class="slide-nav-button icon-arrow-circled--right"></span>',
			appendArrows: '.js-explore-history-slider__nav__buttons',
		})


		// Event - On after change
		$('.js-explore-history-slider').on('afterChange', function(slick, currentSlide){

			
			// console.log(currentSlide.currentSlide);
			
			// Remove class that contains the string 'js-current-slide'
			$('body').removeClass(function(index, className) {
				return (className.match(/(?:^|\s)js-current-slide\S+/g) || []).join(' ');
			});

			$('body').addClass('js-current-slide-' + currentSlide.currentSlide); //Used to adjust animation-duration in css after the first slide is cycled.
			
			// $('.hero-slide', slick.$slides[nextSlide]).trigger('activate-slide-colors');

			//console.log('.main-nav classes after: ', $('.main-nav').attr('class'));

		});


		// Event - On before change
		$('.js-explore-history-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){

			// $('body').addClass('js-active'); //Used to adjust animation-duration in css after the first slide is cycled.

			// $('.hero-slide', slick.$slides[nextSlide]).trigger('activate-slide-colors');

			//console.log('.main-nav classes after: ', $('.main-nav').attr('class'));

		});


	}

		
		
		
		
		

})(jQuery);
